/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import BlogDetail from 'parts/BlogDetail';
import Footer from 'parts/Footer';

import { BlogArticles } from 'json/blogData';

export default class BlogDetailPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <BlogDetail data={BlogArticles} />
        <Footer />
      </>
    );
  }
}
